import CarrierLogo from "@/Shared/Icons/CarrierLogo";
import type { BookShipmentShipmentType } from "@/Shared/Types/bookShipmentSliceTypes";
import { useCoupons } from "@/Shared/Coupons/Hooks/useCoupons";
import { formatPrice } from "@/Helpers/formatPrice";
import { priceBeforeTax } from "@/Helpers/priceBeforeTax";

interface DescribeConfirmQuoteProps {
  shipment: BookShipmentShipmentType;
}

// TODO: This is largely copied from getting started code
export function BookShipmentDescribeConfirmQuote({
  shipment,
}: DescribeConfirmQuoteProps) {
  const { discountQuote } = useCoupons();

  const selectedQuote = shipment?.selectedQuote;

  if (!selectedQuote) {
    return <></>;
  }

  const discountedQuote = discountQuote(selectedQuote);

  const price = formatPrice(
    priceBeforeTax(discountedQuote.price, discountedQuote.taxAmount),
  );

  return (
    <div className="flex flex-col items-start">
      <div className="h-[8px]" />
      <CarrierLogo
        carrierIdentifier={selectedQuote.carrierIdentifier}
        width={100}
        height={30}
        align="left"
      />
      <div className="h-[2px]" />
      <div>
        ${price} {discountedQuote.currency}
      </div>
    </div>
  );
}
